module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iD7B4"))).then(() => parcelRequire('hEqeo'));